import { StorageCountSessionStatus } from '@navio/nsdk';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBadge } from 'noddi-ui-web';
import { STORAGE_COUNT_SESSION_STATUS_LABEL_MAP } from 'noddi-util';
import { STORAGE_COUNT_SESSION_STATUS_ICON } from './StorageCountStatusIcon';

const VARIANT_BY_STATUS = {
  [StorageCountSessionStatus.ACTIVE]: 'info',
  [StorageCountSessionStatus.COMPLETED]: 'success',
  [StorageCountSessionStatus.CANCELLED]: 'outline'
} as const;

export const StorageCountSessionStatusBadge = ({ status }: { status: StorageCountSessionStatus }) => (
  <NoddiBadge variant={VARIANT_BY_STATUS[status]}>
    <NoddiIcon name={STORAGE_COUNT_SESSION_STATUS_ICON[status]} size='small' />
    {STORAGE_COUNT_SESSION_STATUS_LABEL_MAP[status]}
  </NoddiBadge>
);
